import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const categories = [{
    id: 'dermal-fillers',
    title: t('products.dermalFillers'),
    description: t('products.dermalFillersDesc'),
    treatments: [t('products.fineLines'), t('products.deepWrinkles'), t('products.lipEnhancement'), t('products.facialContouring')]
  }, {
    id: 'skin-boosters',
    title: t('products.skinBoosters'),
    description: t('products.skinBoostersDesc'),
    treatments: [t('products.skinHydration'), t('products.brightening'), t('products.fineLinePrevention'), t('products.skinElasticity')]
  }, {
    id: 'medical-ha',
    title: t('products.medicalHA'),
    description: t('products.medicalHADesc'),
    treatments: [t('products.eyeSurgeryAid'), t('products.jointLubrication'), t('products.woundHealing'), t('products.adhesionPrevention')]
  }, {
    id: 'regenerative',
    title: t('products.regenerative'),
    description: t('products.regenerativeDesc'),
    treatments: [t('products.hemostasis'), t('products.woundCare'), t('products.tissueRepair'), t('products.boneRegeneration')]
  }];
  return <section id="products" className="py-24 bg-white" data-id="element-410">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-411">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16" data-id="element-412">
          <div className="max-w-2xl" data-id="element-413">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-414">
              {t('products.label')}
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900" data-id="element-415">
              {t('products.title1')}{' '}
              <span className="font-semibold" data-id="element-416">{t('products.title2')}</span>
            </h3>
          </div>
          <button className="mt-6 md:mt-0 text-brand-copper font-medium hover:text-brand-darkCopper flex items-center group" data-id="element-417">
            {t('products.viewAll')}
            <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-418">
              →
            </span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-419">
          {categories.map((category, index) => <div key={index} className="group relative overflow-hidden rounded-2xl bg-brand-bg p-8 hover:bg-brand-copper transition-colors duration-500 border border-gray-100" data-id="element-420">
              <div className="relative z-10" data-id="element-421">
                <h4 className="text-2xl font-semibold text-gray-900 group-hover:text-white mb-3 transition-colors" data-id="element-422">
                  {category.title}
                </h4>
                <p className="text-gray-600 group-hover:text-white/90 mb-8 transition-colors" data-id="element-423">
                  {category.description}
                </p>

                <ul className="space-y-3" data-id="element-424">
                  {category.treatments.map((treatment, idx) => <li key={idx} className="flex items-center text-sm font-medium text-gray-700 group-hover:text-white/90 transition-colors" data-id="element-425">
                      <span className="w-1.5 h-1.5 rounded-full bg-brand-darkCopper group-hover:bg-white mr-3" data-id="element-426"></span>
                      {treatment}
                    </li>)}
                </ul>
              </div>

              {/* Decorative background number */}
              <div className="absolute -bottom-4 -right-4 text-9xl font-bold text-gray-200/50 group-hover:text-white/10 transition-colors duration-500 z-0 select-none" data-id="element-427">
                0{index + 1}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}